// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39r-V","right":"Footer_right__K0sWu","buttons":"Footer_buttons__1GqGX"};